import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

interface RevenueChartProps {
  data: { month: string; value: number }[];
}

const RevenueChart: React.FC<RevenueChartProps> = ({ data }) => {
  // Calculate total revenue from data
  const totalRevenue = data.reduce((sum, item) => sum + item.value, 0);
  const formattedTotal = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(totalRevenue);

  return (
    <div className="chart-container">
      <div className="chart-header">
        <div>
          <h3>Revenue</h3>
          <p>Understanding your total revenue</p>
        </div>
      </div>
      
      <ResponsiveContainer width="100%" height={220}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis
            dataKey="month"
            tick={{ fontSize: 12, fill: "#677289" }}
            axisLine={false}
            tickLine={false}
            interval={0}
          />
          <YAxis
            tick={{ fontSize: 12, fill: "#677289" }}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: "#fff",
              border: "1px solid #e7ecf1",
              borderRadius: "8px",
            }}
          />
          <Bar dataKey="value" fill="#3957A0" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
      <div className="chart-legend">
        <div className="legend-item">
          <span className="legend-dot" style={{ backgroundColor: "#3957A0" }}></span>
          <span className="legend-label">Monthly Revenue</span>
        </div>
      </div>
      {/* <div className="total-count">
        <p>Total Revenue (Year)</p>
        <h2>{formattedTotal}</h2>
      </div> */}
    </div>
  );
};

export default RevenueChart;
